import Model from "../model";
import Stickers from "../../collection/refbooks/stickers";

import { hashify } from "../../utils/arrays";





export function flatify(fields) { 
    return (fields || [])
        .map( field => [field, ...flatify( field.subfields )] )
        .reduce( (result, array) => [...result, ...array], [] );
}

export function filterAvailableStickers(typeCollection, field, stickerCollection) {
    const { cluster, bindings_array, bindings, is_for_all } = field instanceof Model
        ? field.toJSON()
        : field;

    const isFieldAttachedToTypeDirectly = hashify( (bindings_array || bindings)
        .filter( binding => [true, 't'].includes( binding.on ) )
        .map( binding => binding.type.id ) );
    const isTypeAvailableToField = hashify( typeCollection.toJSON()
        // type and field must be cluster-compatible
        .filter( type =>
            !cluster ||
            !type.cluster ||
            cluster.id == type.cluster.id )
        .map( type => type.id )
        .filter( typeId =>
            is_for_all === 't' || is_for_all === true ||
            isFieldAttachedToTypeDirectly[typeId] ) );

    const availableModels = stickerCollection.models
        // sticker and field must be cluster-compatible
        .filter( sticker =>
            !cluster ||
            !sticker.get( 'cluster' ) ||
            cluster.id == sticker.get( 'cluster' ).id )
        .filter( sticker => 
            sticker.get( 'is_for_all' ) === 't' ||
            sticker.get( 'types' ).some( typeId => isTypeAvailableToField[typeId] ) );

    return new Stickers( availableModels );
}


// WEBPACK FOOTER //
// ./src/js/model/refbooks/field.utils.js